module.exports = __webpack_public_path__ + "media/npc_dota_hero_dazzle.1095f953.webm";